import { KeyboardDatePicker } from '@material-ui/pickers';
import React from 'react';

type Props = React.ComponentProps<typeof KeyboardDatePicker>;

export const DatePickerReadonlyInput = React.forwardRef<any, Props>(
	({ InputProps, disabled, onOpen, onClose, ...rest }, ref) => {
		const [open, setOpen] = React.useState(false);
		return (
			<KeyboardDatePicker
				{...rest}
				ref={ref}
				disabled={disabled}
				open={open}
				onOpen={() => { setOpen(true); onOpen?.(); }}
				onClose={() => { setOpen(false); onClose?.(); }}
				inputProps={{
					...rest.inputProps,
					readOnly: true,
					style: { cursor: disabled ? 'default' : 'pointer', ...rest.inputProps?.style }
				}}
				InputProps={{
					...InputProps,
					onKeyDown: (e) => {
						InputProps?.onKeyDown?.(e);
						if (e.key !== 'Tab') {
							e.preventDefault();
						}
					},
					onClick: (e) => {
						InputProps?.onClick?.(e);
						if (disabled) return;
						setOpen(true);
					}
				}}
			/>
		);
	}
);

DatePickerReadonlyInput.displayName = 'DatePickerReadonlyInput';
